import React, { useEffect, useRef, useState } from 'react';

type cardProps = {
  data: { backGrouund: string; description: string; title: string };
};

const useCountUp = (target: string, duration: number = 2000) => {
  const [display, setDisplay] = useState('0');
  const hasAnimated = useRef(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Extract numeric value and suffix (e.g. "35+" → 35, "+")
    const match = target.match(/^(\d+)(.*)$/);
    if (!match) {
      setDisplay(target);
      return;
    }

    const endValue = parseInt(match[1], 10);
    const suffix = match[2]; // e.g. "+"

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;

          const startTime = performance.now();

          const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Ease-out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.floor(eased * endValue);

            setDisplay(`${current}${suffix}`);

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.3 },
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);

  return { display, ref };
};

const OurWorkCard = ({ data }: cardProps) => {
  const { display, ref } = useCountUp(data.title, 2000);

  return (
    <div className="rounded-xl bg-white px-[12px] pb-3 pt-[8px] shadow-work-card xl:rounded-[38px] xl:px-[32px] xl:pb-[20px]">
      <div className="flex flex-col gap-3 xl:gap-[20px]">
        <div
          ref={ref}
          style={{ backgroundSize: '100% 100%' }}
          className={`flex w-full items-center justify-center ${data?.backGrouund} bg-cover bg-no-repeat py-6 font-opt text-[38px] font-medium leading-[42px] text-primary`}
        >
          {display}
        </div>
        <span className="text-center font-opt text-base font-normal leading-5 text-optDesc">
          {data?.description}
        </span>
      </div>
    </div>
  );
};

export default OurWorkCard;
